//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import {
  IGetLike2BuyStoreResponse,
  ILike2BuyStoreData,
} from '@apis/like2buy/like2buyStoreApiModel';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

function like2buyStoreFetch(
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> {
  return serializedGatewayFetch(
    'instagram_dashboard_gateway',
    `/api/v1/like2buy/store${endpoint}`,
    init,
  );
}

/**
 * Gets Like2Buy store data for the current client
 *
 * GET /api/v1/like2buy/store
 */
export async function getLike2BuyStore(): Promise<
  ILike2BuyStoreData | undefined
> {
  const res = await like2buyStoreFetch(`/`);
  const like2buyStoreReponse = await res.json<IGetLike2BuyStoreResponse>();
  return like2buyStoreReponse.data;
}
